<template>
	<div>
	<ContentHeader />
  <div class="not-found-animated">
    <!-- Particles background -->
    <canvas id="particles"></canvas>

    <!-- Centered content -->
    <div class="content">
      <h1 class="error-code">404</h1>
      <h2 class="error-title">Oops! Page Not Found</h2>
      <p class="error-message">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>
      <router-link to="/" class="btn btn-primary">Go Back Home</router-link>
    </div>
  </div>
  <ContentFooter/>	
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import ContentFooter from "@/components/ContentFooter.vue";
export default {
  name: "NotFoundFancy",
  components: {
	ContentHeader,
	ContentFooter,
  },
  mounted() {
    this.initParticles();
  },
  methods: {
    initParticles() {
      const canvas = document.getElementById("particles");
      const ctx = canvas.getContext("2d");

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      const particlesArray = [];
      const colors = ["#0d6efd", "#6c757d", "#adb5bd", "#495057"];

      // Particle class
      class Particle {
        constructor() {
          this.x = Math.random() * canvas.width;
          this.y = Math.random() * canvas.height;
          this.size = Math.random() * 3 + 1;
          this.speedX = (Math.random() - 0.5) * 1.5;
          this.speedY = (Math.random() - 0.5) * 1.5;
          this.color = colors[Math.floor(Math.random() * colors.length)];
        }
        update() {
          this.x += this.speedX;
          this.y += this.speedY;
          if (this.x < 0 || this.x > canvas.width) this.speedX *= -1;
          if (this.y < 0 || this.y > canvas.height) this.speedY *= -1;
        }
        draw() {
          ctx.fillStyle = this.color;
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
          ctx.fill();
        }
      }

      // Create particles
      for (let i = 0; i < 100; i++) {
        particlesArray.push(new Particle());
      }

      // Animate
      const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particlesArray.forEach((p) => {
          p.update();
          p.draw();
        });
        requestAnimationFrame(animate);
      };
      animate();

      // Handle resize
      window.addEventListener("resize", () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      });
    },
  },
};
</script>

<style scoped>
.not-found-animated {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

canvas#particles {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.content {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 1rem 2rem;
}

.error-code {
  font-size: 10rem;
  font-weight: 900;
  color: #0d6efd;
}

.error-title {
  font-size: 2.5rem;
  color: #212529;
  margin-bottom: 1rem;
}

.error-message {
  color: #495057;
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto 2rem;
}

.btn-primary {
  padding: 0.75rem 2rem;
  font-size: 1rem;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: scale(1.05);
}
</style>
